import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Placeholder } from '@ers/assets/images/avatar.svg';
import cx from 'classnames';
import Types from '../Avatar/AvatarTypes';
import UserPhoto from './UserPhoto';


const UserAvatar = ({ avatar, size }) => (
    <>
        {avatar
            ? <UserPhoto url={avatar} size={size} />
            : (
                <Placeholder
                    className={cx('topbar__avatar--photo', {
                        'topbar__avatar--photo-user-box': size === Types.UserBox
                    })}
                />
            )}
    </>
);
UserAvatar.propTypes = {
    avatar: PropTypes.string,
    size: PropTypes.string
};
UserAvatar.defaultProps = {
    avatar: null,
    size: Types.User
};
export default UserAvatar;
